import { render } from "./ClientEstadoCuentaProveedor.vue?vue&type=template&id=667ae4dc&scoped=true"
import script from "./ClientEstadoCuentaProveedor.vue?vue&type=script&lang=js"
export * from "./ClientEstadoCuentaProveedor.vue?vue&type=script&lang=js"

import "./ClientEstadoCuentaProveedor.vue?vue&type=style&index=0&id=667ae4dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667ae4dc"]])

export default __exports__